import { createAction, handleActions } from 'redux-actions';

const setShowSupplierItemModal = createAction("SCREENS/SUPPLIER_VIEW/SET_SHOW_SUPPLIER_ITEM_MODAL");

const defaultState = false;

const reducer = handleActions(
  {
    [setShowSupplierItemModal]: (state, action) => action.payload
  },
  defaultState
);

export { setShowSupplierItemModal, reducer };
